/* Chrome Drop — code guard. 2026-09-07 (owner): a held game code that Shopify reports as NOT applicable used to vanish silently —
   Liquid drops it (no discount_application), so the drawer, /cart and checkout all showed full price with no explanation, and
   the MEMBERS15 capture popped up in its place. Free-tee winners with a lone tee were the main casualty.
   This script asks the Cart API (POST /cart/update.js {} returns discount_codes[].applicable) and renders ONE line above the
   totals in the drawer and on /cart:
   - (2026-09-19: FREE TEE now unlocks with ANY other item — the three tee lines below describe the old shorts/joggers rule)
   - FREE TEE code, no shorts/joggers in the bag -> red: "Your FREE TEE code needs shorts or joggers in the bag" (+ "Use your 30% off instead"
                                                   button when the game locker holds a live pct code)
   - FREE TEE code, shorts but no tee           -> red: add a tee, it's free with those shorts
   - FREE TEE code, shorts + tee, still dead    -> the code has run out (cap) — swap in the best pct code the player holds and say so
   - pct code dead (cap reached / switched off) -> step down the ladder (50 -> 30 -> 15) and say so
   Never touches MEMBERS15 or any non-game code. Hides the MEMBERS15 capture while a game code is on the bag.
   Re-runs whenever Dawn re-renders the drawer footer or the /cart footer. Loaded by snippets/cart-drawer.liquid and
   sections/main-cart-footer.liquid (double include is safe). Shopify's cart is the truth; the locker only supplies fallback codes. */
(function () {
  'use strict';
  if (window.__ciCodeGuard) return;
  window.__ciCodeGuard = true;
  var KEY = 'ciChromeDrop', MSG = 'ciGuardMsg', TTL = 86400000; /* 2026-09-07 (owner): codes live 24h from the win */
  var busy = false, queued = false, swaps = [], pending = null, lastFoot = null, lastTot = null, cssDone = false;

  function locker() { try { var s = JSON.parse(localStorage.getItem(KEY) || '{}'); return (s && typeof s === 'object') ? s : {}; } catch (e) { return {}; } }
  /* which game code is this? tee / pct (15-99). 100% and everything else (MEMBERS15, secret) -> null = leave alone */
  function kind(c) {
    c = String(c || '').toUpperCase().trim();
    if (!c) return null;
    if (/^CHROME\w*SHORTS/.test(c)) return { kind: 'shorts', p: 0 }; /* 2026-09-17: FREE SHORTS prize — shorts + any other item */
    if (/^CHROME\w*TEE/.test(c)) return { kind: 'tee', p: 0 };
    var m = c.match(/^CHROME(?:FLIGHT|DROP)?(\d{2,3})(?:\b|-)/);
    if (m) { var p = parseInt(m[1], 10); if (p > 0 && p < 100) return { kind: 'pct', p: p }; }
    return null;
  }
  /* pct codes the player has WON and that are still inside their 48h, best first: [{p, code, k}] */
  function heldPct() {
    var s = locker(), w = s.w || {}, lad = s.ladder || [], out = [];
    for (var i = 0; i < lad.length; i++) {
      var l = lad[i];
      if (!l || !l.code || !l.k || !(l.p > 0 && l.p < 100)) continue;
      if (w[l.k] && (Date.now() - w[l.k]) < TTL) out.push({ p: l.p, code: l.code, k: l.k });
    }
    out.sort(function (a, b) { return b.p - a.p; });
    return out;
  }
  /* 2026-09-07: when the code on the bag dies — 24h after the win the game logged, else 24h after APPLY; 0 = unknown (ad link / typed code) */
  function expiresAt(c) {
    var k = kind(c);
    if (!k) return 0;
    var s = locker(), w = s.w || {}, key = k.p ? 'd' + k.p : k.kind;
    if (w[key]) return w[key] + TTL;
    if (s.applied && s.applied.at && String(s.applied.code || '').toUpperCase() === String(c).toUpperCase()) return s.applied.at + TTL;
    return 0;
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function fmtLeft(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return pad2(Math.floor(s / 3600)) + ':' + pad2(Math.floor((s % 3600) / 60)) + ':' + pad2(s % 60); }
  var expTick = null, expAt = 0;
  function expire() {
    if (expTick) { clearInterval(expTick); expTick = null; }
    api({ discount: '' }).then(function () {
      try { sessionStorage.setItem(MSG, '<b>Your code has expired.</b>'); } catch (e) {}
      rerender();
    }).catch(function () {});
  }
  function countdown(at) {
    expAt = at;
    if (expTick) clearInterval(expTick);
    var tick = function () {
      var els = document.querySelectorAll('[data-ci-guard-exp]'), left = expAt - Date.now();
      if (!els.length) { clearInterval(expTick); expTick = null; return; }
      if (left <= 0) { expire(); return; }
      for (var i = 0; i < els.length; i++) els[i].textContent = fmtLeft(left);
    };
    expTick = setInterval(tick, 1000);
    tick();
  }
  function remember(h) { try { var s = locker(); s.applied = { code: h.code, k: h.k, p: h.p, at: Date.now() }; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function api(body) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {}) }).then(function (r) { return r.json(); });
  }
  function holds(cart, c) {
    var l = (cart && cart.discount_codes) || [];
    for (var i = 0; i < l.length; i++) if (String(l[i].code || '').toUpperCase() === String(c).toUpperCase()) return l[i];
    return null;
  }
  function css() {
    if (cssDone) return; cssDone = true;
    var st = document.createElement('style');
    st.textContent = '.ci-guard{margin:0 0 1rem;padding:.9rem 1.1rem;border:1px solid #e02b2b;background:rgba(224,43,43,.1);color:#e8e9ec;font-size:1.15rem;line-height:1.45;letter-spacing:.04em;text-transform:uppercase;text-align:center}' +
      '.ci-guard b{color:#e02b2b;font-weight:800}' +
      '.ci-guard.is-ok{border-color:#2ecc71;background:rgba(46,204,113,.08)}.ci-guard.is-ok b{color:#2ecc71}' +
      '.ci-guard__btn{display:block;width:100%;margin:.7rem 0 0;padding:.8rem 1rem;background:#D94146;color:#0f1013;border:0;border-radius:0;font-weight:800;letter-spacing:.1em;text-transform:uppercase;font-size:1.1rem;cursor:pointer}' +
      '.ci-guard__btn[disabled]{opacity:.6;cursor:default}' +
      '#main-cart-footer .ci-guard{font-size:1.3rem}';
    document.head.appendChild(st);
  }
  /* the line sits directly above the totals: drawer footer + /cart footer (both when both exist) */
  function slots() {
    var out = [], t = document.querySelector('#main-cart-footer .totals'), f = document.querySelector('cart-drawer .cart-drawer__footer');
    if (t) out.push(t);
    if (f) out.push(f);
    return out;
  }
  function paint(html, cls) {
    var old = document.querySelectorAll('[data-ci-guard]');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var fs = document.querySelector('[data-ci-freeship]');
    if (fs) fs.hidden = !!html && cls !== 'is-ok';
    if (!html) return;
    css();
    var s = slots();
    for (var j = 0; j < s.length; j++) {
      var el = document.createElement('div');
      el.className = 'ci-guard ' + (cls || '');
      el.setAttribute('data-ci-guard', '');
      el.setAttribute('role', 'status');
      el.innerHTML = html;
      s[j].parentNode.insertBefore(el, s[j]);
    }
  }
  function btn(h, label) {
    return '<button type="button" class="ci-guard__btn" data-ci-guard-swap="' + h.code.replace(/[^A-Za-z0-9\-]/g, '') + '" data-p="' + h.p + '" data-k="' + h.k + '">' + label + '</button>';
  }
  function membersBlock(hide) {
    var m = document.querySelectorAll('.ci-mcheck');
    for (var i = 0; i < m.length; i++) m[i].hidden = !!hide;
  }
  function oneShot() { try { var m = sessionStorage.getItem(MSG); if (m) sessionStorage.removeItem(MSG); return m || ''; } catch (e) { return ''; } }
  function rerender() {
    /* /cart page: the totals and line prices are server-rendered — reload is the honest refresh */
    if (document.getElementById('main-cart-footer')) { location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    /* refresh the drawer in place WITHOUT Dawn's renderContents() (that also calls open()) */
    api({ sections: ['cart-drawer', 'cart-icon-bubble'] }).then(function (data) {
      if (!data || !data.sections) return;
      var secs = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
      for (var i = 0; i < secs.length; i++) {
        var html = data.sections[secs[i].id];
        if (!html) continue;
        var target = secs[i].selector ? document.querySelector(secs[i].selector) : document.getElementById(secs[i].id);
        if (!target) continue;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector(secs[i].selector || '.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      }
      var ov = d.querySelector('#CartDrawer-Overlay');
      if (ov && typeof d.close === 'function') ov.addEventListener('click', d.close.bind(d));
    }).catch(function () {});
  }
  function swap(h, msg, fail) {
    var now = Date.now();
    swaps = swaps.filter(function (t) { return now - t < 60000; });
    if (swaps.length >= 3) { paint(fail, 'is-warn'); return; }
    swaps.push(now); busy = true;
    api({ discount: h.code }).then(function (c2) {
      busy = false;
      var d = holds(c2, h.code);
      if (!d || d.applicable === false) { paint(fail, 'is-warn'); return; }
      remember(h);
      try { sessionStorage.setItem(MSG, msg); } catch (e) {}
      rerender();
    }).catch(function () { busy = false; });
  }
  /* 2026-09-08 (owner): a WON code attaches itself the moment the bag holds an item. Players who closed the win card without tapping
     APPLY reached checkout at full price (the no-code cohort pays 26% of the time vs 84% with the 50% on). Rules: only when the bag holds
     NO code at all (never over MEMBERS15 / a typed code), only the best live pct code in the locker, once per code per tab
     (sessionStorage) so a shopper who removes it at checkout is not fought. If Shopify says the code is dead, decide() steps down. */
  var AUTO = 'ciAutoCode';
  function tried(c) { try { return (sessionStorage.getItem(AUTO) || '').split('|').indexOf(String(c).toUpperCase()) >= 0; } catch (e) { return false; } }
  function markTried(c) { try { sessionStorage.setItem(AUTO, (sessionStorage.getItem(AUTO) || '') + '|' + String(c).toUpperCase()); } catch (e) {} }
  function autoAttach(h) {
    busy = true; markTried(h.code);
    api({ discount: h.code }).then(function (c2) {
      busy = false;
      var d = holds(c2, h.code);
      if (d && d.applicable !== false) {
        remember(h);
        try { sessionStorage.setItem(MSG, '&#10003; <b>' + h.p + '% OFF applied.</b> Your Warehouse Drop code is on the bag'); } catch (e) {}
        rerender();
        return;
      }
      decide(c2); /* dead (cap reached / switched off): the ladder logic below steps down or explains */
    }).catch(function () { busy = false; });
  }
  function decide(cart) {
    var codes = (cart && cart.discount_codes) || [], items = (cart && cart.items) || [];
    if (!codes.length && cart && cart.item_count) {
      var held0 = heldPct();
      if (held0.length && !tried(held0[0].code)) { autoAttach(held0[0]); return; }
    }
    var game = null, dead = null, deadKind = null;
    for (var i = 0; i < codes.length; i++) {
      var k = kind(codes[i].code);
      if (!k) continue;
      if (!game) game = codes[i];
      if (codes[i].applicable === false && !dead) { dead = codes[i]; deadKind = k; }
    }
    membersBlock(!!game);
    /* an EMPTY bag reports applicable:false for perfectly good codes — never judge without items */
    if (!game || !dead || !cart.item_count) {
      var m = oneShot();
      if (m) { paint(m, 'is-ok'); return; }
      /* 2026-09-07 (owner): a live game code on the bag counts down — "✓ 50% OFF applied — expires in 03:12:44"; at zero it comes off */
      var at = game ? expiresAt(game.code) : 0;
      if (game && cart.item_count && at) {
        var gk = kind(game.code), gl = gk.kind === 'shorts' ? 'FREE SHORTS' : (gk.kind === 'tee' ? 'FREE TEE' : gk.p + '% OFF');
        if (at - Date.now() <= 0) { expire(); return; }
        paint('&#10003; <b>' + gl + ' applied.</b> Expires in <span data-ci-guard-exp style="font-variant-numeric:tabular-nums;color:#ff3b3b;font-weight:800"></span>', 'is-ok');
        countdown(at);
        return;
      }
      paint('', 'is-ok');
      return;
    }
    var hasShorts = false, hasTee = false;
    for (var j = 0; j < items.length; j++) {
      var t = String(items[j].product_type || '');
      if (/shorts|joggers/i.test(t)) hasShorts = true;
      if (/^tee$/i.test(t)) hasTee = true;
    }
    var held = heldPct(), h;
    if (deadKind.kind === 'shorts') {
      /* 2026-09-17 (owner): FREE SHORTS = one pair free with ANY other item in the bag (a second pair counts) */
      var pairs = 0;
      for (var sj = 0; sj < items.length; sj++) if (/^shorts$/i.test(String(items[sj].product_type || ''))) pairs += (items[sj].quantity || 1);
      if (!pairs) {
        paint('<b>Your FREE SHORTS code is waiting.</b> Add a pair of shorts and they come off at checkout' +
          (held.length ? btn(held[0], 'Use your ' + held[0].p + '% off instead') : ''), 'is-warn');
        var slbl = document.querySelector('.ci-dupsell__label');
        if (slbl && /shorts/i.test((slbl.parentNode.querySelector('.ci-dupsell__name') || {}).textContent || '')) slbl.textContent = 'Add these, they go FREE';
        return;
      }
      if (cart.item_count < 2) {
        paint('<b>Your FREE SHORTS code needs one more item in the bag.</b> Add anything and the shorts are free' +
          (held.length ? btn(held[0], 'Use your ' + held[0].p + '% off instead') : ''), 'is-warn');
        return;
      }
      if (held.length) { swap(held[0], '&#10003; <b>Switched to your ' + held[0].p + '% off.</b> The free-shorts code has run out', 'Your FREE SHORTS code has run out. Sale prices still apply'); return; }
      paint('Your FREE SHORTS code has run out. Sale prices still apply', 'is-warn');
      return;
    }
    if (deadKind.kind === 'tee') {
      /* 2026-09-19 (owner): FREE TEE = one tee free with ANY other item in the bag (a second tee counts) — was: needs shorts or joggers */
      var tees = 0;
      for (var tj = 0; tj < items.length; tj++) if (/^tee$/i.test(String(items[tj].product_type || ''))) tees += (items[tj].quantity || 1);
      if (!tees) {
        paint('<b>Your FREE TEE code is waiting.</b> Add a tee and it comes off at checkout' +
          (held.length ? btn(held[0], 'Use your ' + held[0].p + '% off instead') : ''), 'is-warn');
        var lbl = document.querySelector('.ci-dupsell__label');
        if (lbl && /tee/i.test((lbl.parentNode.querySelector('.ci-dupsell__name') || {}).textContent || '')) lbl.textContent = 'Add this, it goes FREE';
        return;
      }
      if (cart.item_count < 2) {
        paint('<b>Your FREE TEE code needs one more item in the bag.</b> Add anything and the tee is free' +
          (held.length ? btn(held[0], 'Use your ' + held[0].p + '% off instead') : ''), 'is-warn');
        return;
      }
      /* tee + another item and still not applicable = the code has run out (cap) — nothing the shopper can add fixes it */
      if (held.length) { swap(held[0], '&#10003; <b>Switched to your ' + held[0].p + '% off.</b> The free-tee code has run out', 'Your FREE TEE code has run out. Sale prices still apply'); return; }
      paint('Your FREE TEE code has run out. Sale prices still apply', 'is-warn');
      return;
    }
    /* pct code dead → step down to the best lower code the player holds */
    h = null;
    for (var q = 0; q < held.length; q++) if (held[q].p < deadKind.p && (!h || held[q].p > h.p)) h = held[q];
    if (h) { swap(h, '&#10003; <b>Switched to your ' + h.p + '% off.</b> The ' + deadKind.p + '% code has sold out', 'Your ' + deadKind.p + '% code has sold out. Sale prices still apply'); return; }
    paint('Your ' + deadKind.p + '% code has sold out. Sale prices still apply', 'is-warn');
  }
  function run() {
    if (!window.fetch || !slots().length) return;
    if (busy) { queued = true; return; }
    busy = true;
    api({}).then(function (cart) { busy = false; decide(cart); }).catch(function () { busy = false; })
      .then(function () { if (queued && !busy) { queued = false; run(); } });
  }
  /* "Use your 30% off instead" — swap the bag's code and say so */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ci-guard-swap]') : null;
    if (!b) return;
    e.preventDefault();
    b.disabled = true; b.textContent = 'Applying…';
    var h = { code: b.getAttribute('data-ci-guard-swap'), p: parseInt(b.getAttribute('data-p'), 10) || 0, k: b.getAttribute('data-k') || '' };
    swap(h, '&#10003; <b>Your ' + h.p + '% off is on.</b> It comes off in your bag', 'That code has run out. Sale prices still apply');
  });
  /* React only when the drawer footer / cart footer has been re-rendered (new elements), never to our own paint */
  function maybeRun() {
    var f = document.querySelector('cart-drawer .cart-drawer__footer'), t = document.querySelector('#main-cart-footer .totals');
    if (f === lastFoot && t === lastTot) return;
    lastFoot = f; lastTot = t;
    run();
  }
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; maybeRun(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
  maybeRun();
})();
